import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Particles } from './Particles';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCta() {
  return <section className="relative overflow-hidden px-5 py-16 sm:px-8" style={{
    background: 'linear-gradient(160deg, #1a1a1a 0%, #2d1b4e 100%)'
  }} data-id="element-33" data-mp="19gijv99xvt6l">
      <Particles data-id="element-34" data-mp="1jclgy0pxp1mo" />

      <div className="relative mx-auto max-w-[500px] text-center" data-id="element-35" data-mp="1jc3hkv7z67aj">
        <ShieldCheckIcon aria-hidden="true" className="mx-auto h-14 w-14 text-gold" strokeWidth={1.4} data-id="element-36" data-mp="1eebkznwdxx00" />
        <h2 className="mt-4 font-display text-[23px] font-bold text-white sm:text-[28px]" data-id="element-37" data-mp="1t2euv8djtsu3">
          Garantía Absoluta de 7 Días
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-38" data-mp="223mgoqyvp17a">
          Aplica el sistema completo durante 7 días. Si no sientes una mejora real y medible, te
          devolvemos el 100% de tu inversión. Sin preguntas. Sin formularios. El riesgo es
          completamente nuestro.
        </p>

        <hr className="mx-auto my-8 w-24 border-0 border-t border-gold/45" data-id="element-39" data-mp="s4p8zfzqjy6o" />

        <p className="text-[15px] text-white/45 line-through" data-id="element-40" data-mp="s6s3ac7x8dh7">$248.00 USD</p>
        <p className="mt-1 font-display text-[44px] font-bold leading-none text-gold sm:text-[60px]" data-id="element-41" data-mp="x27e0vamtt9e">
          $9.99 USD
        </p>

        <a href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="shimmer relative mt-7 block overflow-hidden rounded-xl border-2 border-gold bg-gold px-6 py-4 text-[14px] font-black uppercase tracking-wide text-ink transition-colors duration-200 ease-out hover:bg-gold-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:text-[16px]" data-id="element-42" data-mp="164gm7eifhajm">
          ✅ Quiero sanar ahora — $9.99 USD
        </a>
        <p className="mt-3 text-[12px] text-white/60" data-id="element-43" data-mp="1tu1742y56hvj">
          🔒 Pago seguro · Acceso inmediato · Bono de Numerología incluido gratis hoy
        </p>
      </div>
    </section>;
}